<template>
<div>
  <div style="display:flex;flex-direction: row;">
    <div class="header-tip">
      分摊用户数：{{tableData.length}}
    </div>

    <div class="header-item" style="display:flex;flex-direction: row;">
      <el-input style="width: 180px;" size="mini" v-model="where.house_name" placeholder="输入房产" @change="pageChange(1)"></el-input>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-input style="width: 150px;" size="mini" v-model="where.customer_name" placeholder="输入客户名称" @change="pageChange(1)"></el-input>
      <el-input style="width: 150px;" size="mini" v-model="where.floor" placeholder="输入楼层" @change="pageChange(1)"></el-input>
    </div>
    <div class="header-item">
      <el-button size="mini" type="primary" @click="exportExcel">导出房产</el-button>
      <el-button size="mini" type="primary" @click="importExcel">导入房产</el-button>
      <el-dropdown @command="handleCommand">
        <el-button size="mini" type="primary">
          更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="setProportionExt">设置占比扩展</el-dropdown-item>
          <el-dropdown-item command="setProportionLoss">设置损耗占比</el-dropdown-item>
          <el-dropdown-item command="setProportionTotal">设置基数</el-dropdown-item>
          <el-dropdown-item v-if="apportion_type==='currency'" type="primary" command="setSelectHouseRatioValue">修改系数</el-dropdown-item>
          <el-dropdown-item v-if="apportion_type==='floor'" type="primary" command="dialogVisible=true">楼层系数计算</el-dropdown-item>
          <el-dropdown-item command="deleteHouse">移除</el-dropdown-item>
          <el-dropdown-item command="deleteHouseAll">移除所有</el-dropdown-item>

        </el-dropdown-menu>
      </el-dropdown>
<!--      <el-button size="mini" type="primary" @click="setProportionExt">设置占比扩展</el-button>-->
<!--      <el-button size="mini" type="primary" @click="setProportionLoss">设置损耗占比</el-button>-->
<!--      <el-button size="mini" type="primary" @click="setProportionTotal">设置基数</el-button>-->
<!--      <el-button size="mini" v-if="apportion_type==='currency'" type="primary" @click="setSelectHouseRatioValue">修改系数</el-button>-->
<!--      <el-button size="mini" v-if="apportion_type==='floor'" type="primary" @click="dialogVisible=true">楼层系数计算</el-button>-->
<!--      -->
<!--      <el-button size="mini" type="danger" @click="deleteHouse">移除</el-button>-->
<!--      <el-button size="mini" type="danger" @click="deleteHouseAll">移除所有</el-button>-->
    </div>
  </div>
<!--  <div v-if="apportion_type==='floor'" class="floor-setting-main">-->
<!--    <div v-for="(item,index) in apportion_config_list" :key="index" class="floor-setting-main-item">-->
<!--      <el-tag closable v-if="item.type==='ratio1'" @close="dieList(apportion_config_list,index)">从第{{item.data.start_floor}}层到{{item.data.end_floor}}层，系数从{{ item.data.start_use_floor }}层开始每隔{{ item.data.floor_ratio }}层递增{{ item.data.ratio }}。</el-tag>-->
<!--      <el-tag closable v-if="item.type==='ratio2'" v-for="(item2,index2) in item.data" :key="index2" @close="item.data.length===1?dieList(apportion_config_list,index):dieList(item.data,index2)">从第{{ item2.start_floor }}层到{{ item2.end_floor }}层，系数是：{{item2.ratio}}。</el-tag>-->
<!--    </div>-->
<!--  </div>-->
  <el-table
    v-loading="loading"
    :data="pageData.list"
    border
    @selection-change="handleSelectionChange"
    style="width: 100%" :height="apportion_type==='floor'?'50vh':'50vh'">
    <el-table-column type="selection" width="50"></el-table-column>
    <el-table-column
      prop="customer_name"
      label="分摊客户"
      width="200" fixed>
      <template slot-scope="scope">
        <el-link type="primary" @click="updateCustomer(scope.row)">{{scope.row.customer_name||'设置客户'}}</el-link>
      </template>
    </el-table-column>
    <el-table-column
      prop="house_name"
      label="房产" min-width="320">
    </el-table-column>
    <el-table-column
      prop="value"
      label="系数"
      width="120">
      <template slot-scope="scope">
        <input :disabled="apportion_type!=='currency'" type="number" class="number-input" v-model="scope.row.value" @change="reCompute(scope.row)" />
      </template>
    </el-table-column>
    <el-table-column
      prop="total"
      label="基数"
      width="150">
      <template slot-scope="scope">
        <input disabled type="number" class="number-input" v-model="scope.row.total" />
      </template>
    </el-table-column>
    <el-table-column
      prop="proportion"
      label="分摊占比"
      width="180">
      <template slot-scope="scope">
        <input disabled type="number" class="number-input" v-model="scope.row.proportion" />
      </template>
    </el-table-column>
    <el-table-column
      prop="proportion_ext"
      label="占比扩展"
      width="100">
      <template slot-scope="scope">
        <input type="number" class="number-input" v-model="scope.row.proportion_ext" @change="setValue(scope.row.house_id,'proportion_ext',scope.row.proportion_ext)" />
      </template>
    </el-table-column>
    <el-table-column
      prop="proportion_loss"
      label="损耗占比"
      width="100">
      <template slot-scope="scope">
        <input type="number" class="number-input" v-model="scope.row.proportion_loss" @change="setValue(scope.row.house_id,'proportion_loss',scope.row.proportion_loss)" />
      </template>
    </el-table-column>
    <el-table-column
      prop="is_generate_expenses"
      label="是否生成费用"
      width="100">
      <template slot-scope="scope">
<!--        <input type="number" class="number-input" v-model="scope.row.is_generate_expenses" @change="setValue(scope.row.house_id,'is_generate_expenses',scope.row.is_generate_expenses)" />-->
        <el-switch v-model="scope.row.is_generate_expenses" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="setValue(scope.row.house_id,'is_generate_expenses',scope.row.is_generate_expenses)"></el-switch>
      </template>
    </el-table-column>
    <el-table-column
      prop="fixed_amount"
      label="固定金额"
      width="100">
      <template slot-scope="scope">
        <input type="number" class="number-input" v-model="scope.row.fixed_amount" @change="setValue(scope.row.house_id,'fixed_amount',scope.row.fixed_amount)" />
      </template>
    </el-table-column>
    <el-table-column
      prop="area"
      label="分摊面积"
      width="120">
    </el-table-column>
    <el-table-column
      prop="floor"
      label="楼层"
      width="100">
    </el-table-column>
  </el-table>

  <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;">
    <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>

  <el-dialog
    title="系数设置"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="1000px">
    <FloorCompute v-if="dialogVisible" ref="FloorComputeRef" />
    <template slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="setFloorCompute">确 定</el-button>
    </template>
  </el-dialog>
  <ErpRoomUser ref="ErpRoomUser" />
</div>
</template>

<script>
import ApportionHelper from "./common/ApportionHelper";
import FloorCompute from "./FloorCompute";
import ErpRoomUser from "../../../../../Common/ErpRoomUser";
import {CommonHelp} from "../../../../../Butler/common/CommonHelp";
import ExcelHelp from "../../../../common/ExcelHelp";
import MeterHttp from "../../../../common/MeterHttp";

export default {
  name: "ApportionAverage",
  components: {ErpRoomUser, FloorCompute},
  props:{
    project_id:{type:String|Number,default:()=>""},
    meter_id:{type:String|Number,default:()=>""},
    apportion_type:{type:String,default:()=>"average"},
    fromDataWhere:{type:Object,default:()=>{}}
  },
  data() {
    return {
      dialogVisible:false,
      loading:false,
      tableData: [],
      house_ids:"",
      son_meter_ids:"",
      multipleSelection:[],
      pageData: {
        list: [],
        total: 0,
        pageSize: 500,
        page: 1
      },
      apportion_config_list:[],
      where:{
        house_name:"",
        customer_name:"",
        floor: "",
      },
    }
  },
  mounted() {
    // this.getData();

  },
  methods:{
    getData(){
      const that=this;
      // console.log(that.house_ids)
      // if(!that.house_ids){
      //   return false;
      // }
      let house_ids=that.house_ids;
      if(typeof house_ids==="object"){
        house_ids=house_ids.join(',');
      }
      let son_meter_ids=that.son_meter_ids;
      if(typeof son_meter_ids==="object"){
        son_meter_ids=son_meter_ids.join(',');
      }
      that.loading=true;
      MeterHttp.post("MeterFeeRecipients/getCustomerList",{
        project_id:that.project_id,
        house_ids:house_ids,
        son_meter_ids:son_meter_ids,
        meter_id:that.meter_id,
        house_type:that.fromDataWhere.house_type.join(','),
        customer_class:that.fromDataWhere.customer_class.join(','),
        customer_type:that.fromDataWhere.customer_type.join(','),
        room_status:that.fromDataWhere.room_status.join(','),
      },ret=>{
        console.log(ret.code)
        if(ret.code){
          that.tableData=ApportionHelper[that.apportion_type](ret.data);
          that.pageChange(1);
        }
        console.log("admin/MeterFeeRecipients/getCustomerList")
        that.loading=false
      })
    },
    getHouseCustomer(from_data){
      this.house_ids=from_data.house_ids||'';
      this.apportion_config_list=from_data.apportion_fun?JSON.parse(from_data.apportion_fun):[]
      this.getData();
    },
    getSonMeterCustomer(from_data){
      this.son_meter_ids=from_data.son_meter_ids||[];
      this.apportion_config_list=from_data.apportion_fun?JSON.parse(from_data.apportion_fun):[]
      this.getData();
    },
    setFloorCompute(){
      const that=this;
      let f_data=that.$refs.FloorComputeRef.getData();
      that.dialogVisible=false;
      that.apportion_config_list.push(f_data);
      let tableData=ApportionHelper.compute(ERP.reJson(that.tableData),ERP.reJson(f_data));
      that.tableData=[];
      that.tableData=ApportionHelper.floor2(tableData);
      that.$emit("save",function () {
        that.pageChange(1);
        that.$message.success('设置成功');
      });
    },
    reCompute(item){
      const that=this;
      let tableData=ERP.reJson(that.tableData);
      tableData=ApportionHelper.reCompute(tableData)
      that.tableData=tableData;
      that.$emit("save",function () {
        that.pageChange(1);
        that.$message.success('设置成功');
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteHouse(){
      const that=this;
      if(that.multipleSelection.length===0){
        that.$message.error('勾选分摊客户');
        return false;
      }
      let house_ids=that.multipleSelection.map(ret=>ret.house_id);
      that.tableData=ApportionHelper.deleteHouse(ERP.reJson(that.tableData),house_ids);
      that.$emit("save",function () {
        that.pageChange(1);
        that.$message.success('设置成功');
      });
    },
    deleteHouseAll(){
      const that=this;
      that.tableData=[];
      that.$emit("save",function () {
        that.pageChange(1);
        that.$message.success('设置成功');
      });
    },
    setSelectHouseRatioValue(){
      const that=this;
      if(that.multipleSelection.length===0){
        that.$message.error('勾选分摊客户');
        return false;
      }
      that.$prompt('请输入系数', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(\d+)$|^(\d+)(\.)(\d+)$/,
        inputErrorMessage: '请输入数字'
      }).then(({ value }) => {
        let house_ids=that.multipleSelection.map(ret=>ret.house_id)
        that.tableData=ApportionHelper.setSelectHouseRatioValue(ERP.reJson(that.tableData),house_ids,value);
        that.$emit("save",function () {
          that.pageChange(1);
          that.$message.success('设置成功');
        });
      })
    },
    setProportionExt(){
      const that=this;
      if(that.multipleSelection.length===0){
        that.$message.error('勾选分摊客户');
        return false;
      }
      that.$prompt('请输入扩展占比（扩展占比是直接用的）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(\d+)$|^(\d+)(\.)(\d+)$/,
        inputErrorMessage: '请输入数字'
      }).then(({ value }) => {
        let house_ids=that.multipleSelection.map(ret=>ret.house_id)
        that.tableData=ApportionHelper.setSelectHouseItem(ERP.reJson(that.tableData),house_ids,'proportion_ext',value);
        that.$emit("save",function () {
          that.pageChange(1);
          that.$message.success('设置成功');
        });
      })
    },
    setProportionLoss(){
      const that=this;
      if(that.multipleSelection.length===0){
        that.$message.error('勾选分摊客户');
        return false;
      }
      that.$prompt('请输入线损占比（线损占比是直接用的）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(\d+)$|^(\d+)(\.)(\d+)$/,
        inputErrorMessage: '请输入数字'
      }).then(({ value }) => {
        let house_ids=that.multipleSelection.map(ret=>ret.house_id)
        that.tableData=ApportionHelper.setSelectHouseItem(ERP.reJson(that.tableData),house_ids,'proportion_loss',value);
        that.$emit("save",function () {
          that.pageChange(1);
          that.$message.success('设置成功');
        });
      })
    },
    setValue(house_id,name,value){
      const that=this;
      that.tableData=ApportionHelper.setSelectHouseItem(ERP.reJson(that.tableData),[house_id],name,value);
      that.$emit("save",function () {
        that.pageChange(1);
        that.$message.success('设置成功');
      });
    },
    setProportionTotal(){
      const that=this;
      that.$prompt('请输入基数（系数的总数）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(\d+)$|^(\d+)(\.)(\d+)$/,
        inputErrorMessage: '请输入数字'
      }).then(({ value }) => {
        let tableData=ERP.reJson(that.tableData);
        tableData=ApportionHelper.allUpdate(tableData,'total',value);
        tableData=ApportionHelper.reProportion(tableData);
        that.tableData=tableData;
        that.$emit("save",function () {
          that.pageChange(1);
          that.$message.success('设置成功');
        });
      })
    },
    updateCustomer(item){
      const that=this;
      that.$refs.ErpRoomUser.show(data=>{
        if(data.id){
          item.customer_id=data.id;
          item.customer_name=data.name;
          that.$message.success('设置成功');
        }else {
          that.$message.error('未选择分摊客户');
        }
        that.$emit("save",function () {
          that.pageChange(1);
          that.$message.success('设置成功');
        });
      },"")
    },
    getTableData(){
      return ERP.reJson(this.tableData)
    },
    pageChange(i=1){
      const that=this;
      that.loading=true;
      that.pageData.page = i;
      let list=ERP.reJson(that.tableData);
      list=ApportionHelper.whereList(list,that.where)
      that.pageData.total = list.length;
      that.pageData.list=list.splice((that.pageData.page-1)*that.pageData.pageSize,that.pageData.pageSize);
      that.loading=false;
    },
    dieList(list=[],index=0){
      list.splice(index,1)
    },
    getApportionConfigList(){
      return ERP.reJson(this.apportion_config_list);
    },
    exportExcel(){
      const that=this;
      let file_name="房产分摊列表-".concat(new Date().toLocaleString());
      ExcelHelp.json2Excel(ERP.reJson(that.tableData),{
        house_name: "房产",
        customer_name: "客户名称",
        value: "系数",
        total: "基数",
        proportion: "分摊占比",
        proportion_ext: "占比扩展",
        proportion_loss: "损耗占比",
        area: "面积",
        floor: "楼层",
        is_generate_expenses: "是否生成费用(0:否,1:是)",
        fixed_amount: "固定金额",
        create_time: "添加时间",
        update_time: "修改时间",
        customer_id: "客户ID",
        project_id: "项目ID",
        house_id: "房产ID",
        id: "对象ID",
      },file_name)
    },
    importExcel(){
      const that=this;
      ExcelHelp.importFile(data=>{
        let titleObj={
          house_name: "房产",
          customer_name: "客户名称",
          value: "系数",
          total: "基数",
          proportion: "分摊占比",
          proportion_ext: "占比扩展",
          proportion_loss: "损耗占比",
          area: "面积",
          floor: "楼层",
          is_generate_expenses: "是否生成费用(0:否,1:是)",
          fixed_amount: "固定金额",
          create_time: "添加时间",
          update_time: "修改时间",
          customer_id: "客户ID",
          project_id: "项目ID",
          house_id: "房产ID",
          id: "对象ID",
        };
        let obj_keys=Object.keys(titleObj);
        let obj_values=Object.values(titleObj);
        let data_list=[];
        data.map(ret=>{
          let item={};
          obj_values.map((val,index)=>{
            item[obj_keys[index]]=ret[val];
          });
          data_list.push(item)
        })
        that.tableData=ERP.reJson(data_list);

        that.$emit("save",function () {
          that.pageChange(1);
          that.$message.success('设置成功');
        });
      })
    },
    handleCommand(command) {
      const that = this;
      switch (command) {
        case "setProportionExt":
          that.setProportionExt();
          break;
        case "setProportionLoss":
          that.setProportionLoss();
          break;
        case "setProportionTotal":
          that.setProportionTotal();
          break;
        case "setSelectHouseRatioValue":
          that.setSelectHouseRatioValue();
          break;
        case "dialogVisible=true":
          that.dialogVisible=true;
          break;
        case "deleteHouse":
          that.deleteHouse();
          break;
        case "deleteHouseAll":
          that.deleteHouseAll();
          break;
        default:
          break;
      }
    },
  },
  watch:{
    "fromDataWhere.house_type":{
      deep:true,
      immediate:true,
      handler(){
        const that=this;
        CommonHelp.throttle(function () {
          that.getData();
        },500,that);
      }
    },
    "fromDataWhere.customer_class":{
      deep:true,
      immediate:true,
      handler(){
        const that=this;
        CommonHelp.throttle(function () {
          that.getData();
        },500,that);
      }
    },
    "fromDataWhere.customer_type":{
      deep:true,
      immediate:true,
      handler(){
        const that=this;
        CommonHelp.throttle(function () {
          that.getData();
        },500,that);
      }
    },
    "fromDataWhere.room_status":{
      deep:true,
      immediate:true,
      handler(){
        const that=this;
        CommonHelp.throttle(function () {
          that.getData();
        },500,that);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../common";
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
.header-item{
  margin: 5px 5px;
}
.number-input{
  background-color: #ffe5d5;
  color: black;
  width: 100%;
  &[disabled]{
    background-color: #ececec;
  }
}
.floor-setting-main{
  height: 10vh;
  overflow-y: scroll;
  padding: 2px;
  border: 1px solid #d7d7d7;
  border-radius: 2px;
  .floor-setting-main-item{
    padding: 2px 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/apportion/Apportion.vue